<template>
  <div>

    <!-- ALERTA -->
    <div @click="resetAlert();" transition="slide-y-transition">
      <v-alert transition="slide-y-transition" v-model="alert" dismissible outline :color="alertColor" :type="alertType">
        {{alertMessage}}
      </v-alert>
    </div>

    <v-toolbar flat transition="slide-y-reverse-transition">
      <v-toolbar-title class="font-weight-light">{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Pesquisar" single-line hide-details></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="900px" persistent :loading="loading">
        <v-btn slot="activator" :disabled="loading" :loading="loading" color="info" icon round @click="actionNewButton();">
          <v-icon>add</v-icon>
        </v-btn>


        <!-- FORMULÁRIO -->
        <v-card>
          <v-toolbar color="white" class="elevation-1 font-weight-light" card>
            <v-toolbar-title class="headline font-weight-light">
              {{dynamicDialogTitle}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-switch class="pt-switch" :disabled="loading" :label='additional.active ? "Ativa" : "Inativa"' v-model="additional.active"></v-switch>
              <v-btn :disabled="loading" color="error" title="Cancelar" icon round flat @click="closeDialog('modal')">
                <v-icon large>clear</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <div @click="additional = {}" pa-4 ma-4 pt-5>
            <v-alert pa-4 ma-4 pt-5 transition="slide-x-reverse-transition" v-model="alertForm" dismissible :type="alertType">
              <span v-for="msg in alertMessageForm" :key="msg">{{ msg }} <br></span>
            </v-alert>
          </div>

          <v-card-text transition="fade-transition">
            <v-flex xs12>
              <v-text-field box v-model="additional.value" label="Valor * (R$)" type="number"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field box v-model="additional.description" label="Descrição *" autofocus></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea no-resize label="Observações" :value="additional.observation" rows="5" box></v-textarea>
            </v-flex>
          </v-card-text>

          <br>
          <v-footer class="white--text pa-3 mb-3 mx-3 elevation-1" style="border-radius: 5px;" height="auto" width="100%"
            color="info">
            <span>
              Os campos marcados com o (*) são obrigatórios
            </span>
          </v-footer>
          <br>

          <v-card-actions class="actions-padding">
            <v-btn :disabled="loading" color="success lighten-1" block round :loading="loading" large @click="save();">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>


    <!-- TABELA -->
    <v-data-table rows-per-page-text="Colunas por página" transition="slide-y-reverse-transition"  :search="search" :headers="headers" :items="additionals" class="elevation-1"
      :loading="loading">
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.description }}</td>
        <td class="text-xs-center">{{ props.item.value | currency }}</td>
        <td class="text-xs-center">
          <v-chip small class="white--text font-weight-light" :color="props.item.active == false ? 'error' : 'success lighten-1' "
            :disabled="props.item.active == false">{{props.item.active == false ? 'Inativa' : 'Ativa'}}</v-chip>
        </td>
        <td class="justify-center layout px-0">
          <v-btn :disabled="loading" flat icon round title="Editar">
            <v-icon color="info" @click="edit(props.item);">
              edit
            </v-icon>
          </v-btn>
          <v-btn :disabled="loading" flat icon round title="Detalhes">
            <v-icon color="info" @click="detailAdditional(props.item);">
              info
            </v-icon>
          </v-btn>
        </td>
      </template>
      <div slot="no-results" :value="true">
        <h3 class="text-xs-center">{{emptySearchText}} "{{ search }}".</h3>
      </div>
      <template slot="footer" v-if="records > 0">
        <td colspan="100%">
          <strong class="font-weight-light">{{ dynamicFooterText }}</strong>
        </td>
      </template>
      <template slot="no-data" v-else>
        <strong class="font-weight-light"> {{dynamicNoDataText}} </strong>
      </template>
      <template slot="pageText" slot-scope="props" class="font-weight-light">
        Linhas {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
      </template>
    </v-data-table>


    <!-- DETALHES -->
    <v-dialog v-model="dialogDetails" max-width="900px" :loading="loading">
      <v-card>
        <v-toolbar class="elevation-1" card color="white">
          <v-toolbar-title class="headline font-weight-light">
            {{dialogDetailsTitle}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn color="error lighten-1" title="Cancelar" icon round flat @click.stop.prevent="closeDialog('details')">
              <v-icon large>clear</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout v-if="additional" row wrap justify-start class="font-weight-light ">
              <v-flex xs12 mb-3>
                <span ml-2 pl-2 class="headline font-weight-light">Situação: <span :class="additional.active ? 'green--text font-weight-light' : 'red--text font-weight-light'">{{
                    additional.active ? "Ativo" : "Inativo" }}</span></span>
              </v-flex>
              <v-flex xs6 mb-1>
                <v-text-field label="Base do Cálculo" readonly box v-model="additional.calculationBase"></v-text-field>
              </v-flex>
              <v-flex xs6 mb-1>
                <v-text-field label="Percentual" readonly box v-model="additional.percentual"></v-text-field>
              </v-flex>
              <v-flex xs12 mb-1>
                <v-text-field label="Descrição" box readonly v-model="additional.description"></v-text-field>
              </v-flex>
              <v-flex xs12 mb-1>
                <v-textarea label="Observação" readonly box v-model="additional.observation"></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
  import AdditionalWorkService from "../service/AdditionalWorkService";

  export default {
    data: () => ({
      /****************\
      **Visual/Dialogs**
      \****************/
      loading: false,
      /* Alerta */
      alertType: "info",
      alertColor: "",
      alert: false,
      alertMessage: [],
      alertForm: false,
      alertMessageForm: [],
      /* Dialogs */
      dialog: false,
      dialogRemove: false,
      dialogDetails: false,
      loading: true,
      search: "",
      /*******\
      **Texto**
      \*******/
      loadingRecordsText: "Carregando Registros...",
      emptyRecordsText: "Nenhum registro foi encontrado.",
      emptySearchText: "Nenhum registro encontrado para",
      dialogDetailsTitle: "Detalhes do Adicional de Trabalho",
      dialogEditingTitle: "Alterar Adicional de Trabalho",
      dialogCreatingTitle: "Cadastrar Adicional de Trabalho",
      emptyRecordsText: "Nenhum Registro Encontrado",
      footerTotalRecordsText: "Total de Registros",
      footerLoadingRecordsText: "Carregando",
      title: "Listagem de Adicionais de Trabalho",
      /**********\
      **Recursos**
      \**********/
      additionals: [],
      additional: {
        value: 0
      },
      records: 0,
      /************\
      **Data-Table**
      \************/
      headers: [{
          text: "Descrição",
          align: "center",
          value: "description"
        },
        {
          text: "Valor (R$)",
          align: "center",
          value: "value"
        },
        {
          text: "Situação",
          align: "center",
          value: "active"
        },
        {
          text: "",
          align: "center",
          value: "active",
          sortable: false
        }
      ]
    }),

    created() {
      this.initialize();
    },

    watch: {
      dialog(val) {
        val || this.initialize();
      },

      dialogDetails(val) {
        val || this.initialize();
      },
    }, //watch

    computed: {
      dynamicFooterText() {
        let text = `${this.records > 0 ? this.footerTotalRecordsText : this.emptyRecordsText } : ${this.records} `
        return `${this.loading ? '' : text}`
      },
      dynamicNoDataText() {
        let text = this.loading ? this.loadingRecordsText : this.emptyRecordsText;
        return text
      },
      dynamicDialogTitle() {
        let text = this.additional._id ? this.dialogEditingTitle : this.dialogCreatingTitle;
        return text
      }
    },

    methods: {
      async initialize() {
        this.loading = true;
        try {
          await this.getAll();
          this.additional = {};
          this.dialog = false;
          this.calculateRecords();
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false;
        }
      },

      /*********************\
      **Visual/Estatisticas**
      \*********************/

      actionNewButton() {
        this.resetAlert();
        this.additional = {};
      },


      /* Estatisticas */

      calculateRecords() {
        let amount = 0;
        for (let i = 0; i < this.additionals.length; i++) {
          amount++;
        }
        this.records = amount;
      },

      validateFields() {
        if (!this.additional || !this.additional.description) {
          this.showAlert('form', "Descrição deve ser informada", "error", "error");
        }

        return this.alertMessageForm.length == 0 ? true : false;
      },

      /* Dialogs */

      detailAdditional(item) {
        this.additional = Object.assign({}, item);
        this.dialogDetails = true;
      },

      closeDialog(dialog) {
        this.loading = true;
        try {
          this.additional = new Object();
          switch (dialog) {
            case 'modal':
              this.dialog = false;
              break;

            case 'details':
              this.dialogDetails = false;
              break;

            case 'remove':
              this.dialogRemove = false;
              break;

            default:
              this.dialog = false;
              this.dialogRemove = false;
              this.dialogDetails = false;
              break;
          }
        } catch (error) {
          console.log(`Erro ao fechar dialog : ${new Error(error)}`);
        } finally {
          this.loading = false;
        }
      },

      /* Alert */

      resetAlert() {
        this.alertMessage = "";
        this.alertMessageForm = [];
        this.alertType = "info";
        this.alertColor = "";
        this.alert = false;
      },

      showAlert(place, msg, color, type, timeout) {
        if (this.alert == true) this.resetAlert();
        if (msg != "" || undefined || null) place == 'form' ? this.alertMessageForm.push(msg) : this.alertMessage = msg;
        if (type != "" || undefined || null && !color) this.alertType = type;
        else if (color != "" || undefined || null && !type) this.alertColor = color, this.alertType = "";
        else if (!type && !color) this.alertType = "info";
        place == 'form' ? this.alertForm = true : this.alert = true;
        if (timeout != undefined || null) {
          let _t = Math.min(timeout, 10000);
          let _timeout = Math.max(timeout, 1000);
          if (_timeout) {
            setTimeout(() => {
              if (!this.alert) return;
              if (this.alertMessage == msg) this.resetAlert();
            }, _timeout || 5000);
          }
        };
      },

      /*********\
      **Getters**
      \*********/

      async getAll() {
        this.loading = true;
        try {
          this.additionals = await AdditionalWorkService.getAll();
        } catch (error) {
          this.showAlert(
            'a',
            "Ocorreu um erro ao tentar listar os Adicionais de Trabalho cadastrados. Por favor contate o suporte técnico.",
            "error",
            "error"
          );
          console.log(error.message);
          return;
        } finally {
          this.loading = false;
        }
      },

      /******\
      **CRUD**
      \******/

      edit(item) {
        this.resetAlert();
        this.additional = Object.assign({}, item);
        this.dialog = true;
      },

      async save() {
        this.resetAlert();

        if (!this.validateFields()) return (this.alertForm = true);

        if (this.additional._id) {
          // EDITAR
          try {
            await AdditionalWorkService.edit(this.additional);
            this.showAlert('a', "Adicional de Trabalho alterado com sucesso", "success", "success");
          } catch (error) {
            this.showAlert(
              'a',
              "Ocorreu um erro ao tentar alterar o Adicional de Trabalho. Por favor contate o suporte técnico.",
              "error",
              "error"
            );
            this.initialize();
            console.log(error.message);
            return;
          }
        } else {
          // SALVAR
          try {
            await AdditionalWorkService.save(this.additional);
            this.showAlert('a', "Adicional de Trabalho criado com sucesso", "success");
          } catch (error) {
            this.showAlert(
              'a',
              "Ocorreu um erro ao tentar criar o Adicional de Trabalho. Por favor contate o suporte técnico.",
              "error"
            );
            this.initialize();
            console.log(error.message);
            return;
          }
        }

        this.dialog = false;
      }
    },
  };

</script>
<style scoped>
  .actions-padding {
    padding-bottom: 19px;
    padding-left: 18px;
    padding-right: 18px;
  }

  .pt-switch {
    padding-top: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/AdditionalWork.vue